import script from "./SohaStarRating.vue?vue&type=script&setup=true&lang=js"
export * from "./SohaStarRating.vue?vue&type=script&setup=true&lang=js"

import "./SohaStarRating.vue?vue&type=style&index=0&id=7e804dca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e804dca"]])

export default __exports__